import { render, staticRenderFns } from "./aquit-alerts.vue?vue&type=template&id=4553b7f8"
import script from "./aquit-alerts.vue?vue&type=script&lang=js"
export * from "./aquit-alerts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports